import { Box, Input,  styled, SxProps, useTheme } from "@mui/material";
import { StyleguideSavioColors, StyleguideSavioFonts } from "../../../../configuration/themeSettings";
import { Link } from "react-router-dom";


export const LinkStyled = styled(Link, { label: "TableColumnComponent-LinkStyled" })(
    ({ theme }) => ({
      
        textDecoration: 'none',
        color: StyleguideSavioColors.text.black,
        fontWeight: StyleguideSavioFonts.normal,
        ".MuiBox-root":{
            display: 'flex',
            alignItems: 'center',
        }
    })
);


